import { AnyAction, PayloadAction, createAction } from '@reduxjs/toolkit';

import type { AnyApi } from '../../buildCreateApi';

/**
 * Формат мета-информации в экшенах {reducerPath}/executeMutation/fulfilled.
 * Экшен создается внутри RTK Query, но не экспортируется.
 */
export type MutationFulfilledAction = PayloadAction<
    unknown,
    string,
    {
        arg: {
            endpointName: string;
            originalArgs: unknown;
        };
        baseQueryMeta: unknown;
    },
    unknown
>;

/**
 * Создает функцию-матчер, которая определяет является ли экшен резолвом мутации.
 * @param api Инстанс RTK Query API.
 * @returns Функция-матчер, которая определяет является ли экшен резолвом мутации.
 */
export function createMutationFulfilledActionMatcher<Api extends AnyApi>(api: Api) {
    const mutationFulfilledAction = createAction(`${api.reducerPath}/executeMutation/fulfilled`);

    return function match(action: AnyAction): action is MutationFulfilledAction {
        return mutationFulfilledAction.match(action);
    };
}
